// extracted by mini-css-extract-plugin
export default {"docTitle":"Document_docTitle__RTcaZ","docSubTitle":"Document_docSubTitle__00mvg"};